export class Direccion {
    id: number;
    idPais: number;
    pais: string;
    idDepartamento: number;
    departamento: string;
    idMunicipio: number;
    municipio: string;
    barrio: string;
    direccion: string;
    esPrincipal: boolean;
    indicaciones: string;
}
